<template>
  <div class='EnbProdutos'>
    <div class="cont-itens">
      <div class="itens">
        <component
        :is="!Prefes.componentProd ? 'EnbItem01' : Prefes.componentProd.name"
        v-for="(i, key) in ProdutosStore.length ? ProdutosStore : DefaultProdutos"
        :key="key"
        :data="i"
        />
      </div>
      <div class="widget-rigth">
        <div class="cont-filter">
          <enb-filter-price2
          v-if="loadPriceRange"
          v-model="valores" 
          :min="priceRange[0]" 
          :max="priceRange[1]" 
          :step="1"
          @update:modelValue="() => filterPrice(valores)"
          />
        </div>
        <enb-banner/>
        <enb-map/>
      </div>
    </div>
    <div class="cont-loader">
      <component
      :is="Prefes.spinner.tipo"
      :color="Prefes.spinner.cor"
      :size="Prefes.spinner.tipo === 'EnbSyncLoader' ? '12px' : '40px'"
      style="z-index: 999"
      v-if="load"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Products from '@/components/Products'
import { loaders } from '@/components/Spinner'
import EnbMap from '../Map/EnbMap'
import EnbBanner from '../Banner/EnbBanner'
import EnbFilterPrice2 from '../Filter/EnbFilterPrice2'
export default {
  name: 'EnbProdutos',
  components: { ...Products, ...loaders, EnbMap, EnbBanner, EnbFilterPrice2 },
  computed: {
    ...mapGetters(['Prefes', 'FilterProdStore', 'ProdutosStore'])
  },
  props: ['data'],
  data () {
    return {
      load: false,
      loadPriceRange: false,
      priceRange: [0, 0],
      valores: [0, 0],
      timeout: null,
      scroll: {
        position: 0,
        height: 1
      },
      DefaultProdutos: [
        {
          id: 9999,
          code: '99999',
          tipo: 'Simples',
          name: 'Seu Produto',
          status: true,
          preco: 1.99,
          oferta: 1.99,
          img: [],
          descricao: 'Descrição do seu produto',
          dateOfertaStart: '',
          dateOfertaEnd: '',
          categoria: '',
          gerEstoque: false,
          statusEstoque: '',
          estoque: 1,
          exibeSemEstoque: true,
          pendencia: '',
          visibilidade: 1,
          visualizacao: 1,
          atributos: [],
          estoqueVariavel: [],
          caracter: [],
          destaque: true,
          dateCreate: new Date(),
          link: ''
        }
      ]
    }
  },
  watch: {
    data (n) {
      if ((n.scroll.position + 57) >= n.scroll.height) {
        this.push()
      }
    }
  },
  methods: {
    ...mapActions(['GetStoreProducts', 'GetFilterPrice', 'GetProducFilterPrice', 'Loading']),
    push () {
      this.load = true
      setTimeout(() => {
        if(!this.ProdutosStore.length) {
          this.load = false
          return
        }
        this.GetStoreProducts({ params: {
          last: this.ProdutosStore.map(p => p.id),
          limit: 4,
          categoria: this.FilterProdStore.categoria === '' ? this.$route.params.categ : this.FilterProdStore.categoria
        }, init: false })
        .then(() => {
          this.load = false
        })
      }, 2000)
    },
    filterPrice (range) {
      if(this.timeout !== null) {
        clearTimeout(this.timeout)
      }
      this.timeout = setTimeout(() => {
        this.GetProducFilterPrice({ min: range[0], max: range[1] })
      }, 1000)
    }
  },
  created () {
    this.Loading(true)
    this.GetStoreProducts({
      params:
      { 
        last: [],
        limit: 8,
        categoria: typeof this.$route.params.categ !== 'undefined' ? this.$route.params.categ : ''
      }
      ,
      init: true
    })
    .then(() => this.GetFilterPrice())
    .then(res => {
      this.priceRange = res
      this.valores = res
      this.loadPriceRange = true
      this.Loading(false)
    })
  }
}
</script>

<style scoped>
.EnbProdutos {
  width: 98%;
  padding: 1%;
}

.cont-itens {
  width: 100%;
  display: flex;
  align-items: start;
  justify-content: center;
}

.itens {
  width: 80%;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  padding: 1%;
}

.cont-loader {
  height: 60px;
}

.widget-rigth {
  width: 20%;
}

.cont-filter {
  width: 75%;
  margin: auto;
}

@media (max-width: 500px) {
  .itens {
    width: 100%;
  }
  .widget-rigth {
    display: none;
  }
}
</style>
